var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1429 10.7143H13.2857V6.85714C13.2857 6.40179 12.8839 6 12.4286 6H11.5714C11.0893 6 10.7143 6.40179 10.7143 6.85714V10.7143H6.85714C6.375 10.7143 6 11.1161 6 11.5714V12.4286C6 12.9107 6.375 13.2857 6.85714 13.2857H10.7143V17.1429C10.7143 17.625 11.0893 18 11.5714 18H12.4286C12.8839 18 13.2857 17.625 13.2857 17.1429V13.2857H17.1429C17.5982 13.2857 18 12.9107 18 12.4286V11.5714C18 11.1161 17.5982 10.7143 17.1429 10.7143Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.c2fdb01b7a8a66d6a84650ab81f3bd90.svg";
export { ForwardRef as ReactComponent };